import { LeafletMarker } from './models/leaflet-marker.model';

import { Component, DoCheck, Input, IterableDiffers } from '@angular/core';

import * as L from 'leaflet';
import { LeafletBlockComponent } from '../leaflet-block-component.interface';

@Component({
    selector: 'leaflet-marker',
    template: '',
    standalone: false
})
export class LeafletMarkerComponent implements LeafletBlockComponent, DoCheck {
	@Input() public name: string;
	@Input() public isDefault: boolean = true;
	@Input() public includeInOverlays: boolean = true;

	@Input() public tooltipHTML: string;
	
	@Input() public icon: any;

	private _data: LeafletMarker[];
	@Input()
	public get data(): LeafletMarker[] { return this._data; };
	public set data(value: LeafletMarker[]) {
		this._data = value;

		console.error(this._data);

		this.updateLayerGroup();
	}

	@Input() public dataAccessExpressionKey: string | undefined;

	public _layerGroup: any;

	public updateLayerGroup(additively: boolean = false): void {
		if (!this._layerGroup) {
			return;
		}

		if (!additively) {
			this._layerGroup.clearLayers();
		}

		let markers = [];

		for (let a = 0; a < this._data.length; a++) {
			const { coordinates, ...options } = this.dataAccessExpressionKey ? this._data[a][this.dataAccessExpressionKey] : this._data[a];
		
			const marker = L.marker(
				[
					coordinates.latitude,
					coordinates.longitude
				],
				Object.assign({}, options)
			);

			let tooltip = options.tooltipHTML || this.tooltipHTML;

			if (tooltip) {
				marker.bindTooltip(tooltip);
			}

			marker.on(
				'click',
				(e: any) => {
					options.onClick(e);

		
				}
			);

			marker.on(
				'mouseover',
				(e) => {
					
				}
			);

			marker.on(
				'mouseout',
				(e) => {
					
				}
			);

			markers.push(marker);
		}

		for (let a = 0; a < markers.length; a++) {
			this._layerGroup.addLayer(markers[a]);
		}
	}

	public initialize(layerGroup: L.LayerGroup, map: L.Map) {
		this._layerGroup = layerGroup;

		this.updateLayerGroup();
	}

	private iterableDiffer: any;

	constructor(private _iterableDiffers: IterableDiffers) {
    this.iterableDiffer = this._iterableDiffers.find([]).create(null);
	}

	ngDoCheck(): void {
		let changes = this.iterableDiffer.diff(this._data);
    
		if (changes) {
			console.log('Changes detected!', this._data);

			this.updateLayerGroup();
		}
	}
}
